<template>
  <div>
    <van-search
      v-model="value"
      label="库房"
      placeholder="请输入两字以上关键词搜索来源"
      input-align="center"
      show-action
      @search="onSearch"
    >
      <template #action>
        <div @click="onSearch">搜索</div>
      </template>
    </van-search>
    <van-pull-refresh v-model="loading" success-text="刷新成功" @refresh="query">
      <van-cell v-for="item in data" :key="item.id" :title="item.name" @click="handleClick(item)">
        <template>
          {{ item.type_name }}
        </template>
      </van-cell>
    </van-pull-refresh>
    <van-col v-if="data.length === 0" :span="24" style="text-align: center; font-size: 14px; color: gray;">
      {{ CONST.EMPTY_MSG }}
    </van-col>
  </div>
</template>

<script>
import { getStorageList } from '@/api/settings/storage'
export default {
  name: 'BaseSearchStorageList',
  data() {
    return {
      loading: false,
      data: [],
      value: '',
      keywords: ''
    }
  },
  methods: {
    query() {
      this.loading = true
      this.data = []
      getStorageList({
        page: this.CONST.PAGINATION.PAGE,
        rows: this.CONST.PAGINATION.MAX_ROWS,
        sort: 'id',
        order: 'desc',
        name: this.keywords
      }).then(resp => {
        this.data = resp.rows || []
      })
      this.loading = false
    },
    onSearch() {
      this.keywords = this.value.trim()
      if (this.keywords && this.keywords.length >= 2) {
        this.query()
      } else {
        this.toast('请您至少输入两个字进行检索')
      }
    },
    handleClick(item) {
      this.$emit('change', item)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/base/BaseSearchStorageList.vue